/*
 * @创建文件时间: 2020-06-29 00:10:20
 * @最后修改人: lfq
 * @最后修改时间: 2020-07-14 15:25:52
 * @联系Qq:1360484677
 * @文件介绍: 
 */
export default [{
    path: 'egOne',
    name: 'egOne',
    meta: {
        title: '测试',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/bTCChecks/bCCheck/egOne')
}, {
    path: 'egDuble',
    name: 'egDuble',
    meta: {
        title: '测试2',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/bTCChecks/bCCheck/egDuble')
}, {
    path: 'newIndex',
    name: 'newIndex',
    meta: {
        title: '新首页',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/bTCChecks/bCCheck/newIndex')
}, ]